const stationsFr = {
  AIG: 'Aigle',
  ALT: 'Altdorf',
  ANT: 'Andermatt',
  RAG: 'Bad Ragaz',
  BER: 'Berne',
  BAS: 'Bâle',
  CHM: 'Chaumont',
  CHD: 'Château-d’Oex',
  GSB: 'Col du Grand St-Bernard',
  DAV: 'Davos',
  ELM: 'Elm',
  ENG: 'Engelberg',
  GVE: 'Genève',
  GRC: 'Grächen',
  GRH: 'Hospice du Grimsel',
  JUN: 'Jungfraujoch',
  CDF: 'La Chaux-de-Fonds',
  LCR: 'La Cure',
  SAE: 'Le Säntis',
  DAB: 'Les Diablerets',
  OTL: 'Locarno',
  LUZ: 'Lucerne',
  LUG: 'Lugano',
  MER: 'Meiringen',
  NEU: 'Neuchâtel',
  PAY: 'Payerne',
  STG: 'Saint-Gall',
  SAM: 'Samedan',
  SBE: 'San Bernardino',
  SIA: 'Segl-Maria',
  SIO: 'Sion',
  YVD: 'Yverdon-les-Bains',
  SMA: 'Zurich',
}

export { stationsFr }
